export default __webpack_public_path__ + "static/appliances_w.c33e524148fedf142e1eb895d52a9613.svg";